(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('TelehealthMeeting', TelehealthMeeting);

    TelehealthMeeting.$inject = ['$resource', 'DateUtils'];

    function TelehealthMeeting ($resource, DateUtils) {
        var resourceUrl =  'api/telehealth-meetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.telehealthMeetingRecurrence.endDate = DateUtils.convertLocalDateFromServer(data.telehealthMeetingRecurrence.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'saveAll': {url: 'api/telehealth-meetings/save-all', method: 'POST', isArray: false},
            'delete': {url: 'api/telehealth-meetings/:id', method: 'DELETE', isArray: false},
            'findAllByFilter': {url: 'api/telehealth-meetings/filter', method: 'GET', isArray: true},
            'startMeeting': {url: 'api/telehealth-meetings/start', method: 'GET', isArray: false},
            'endMeeting': {url: 'api/telehealth-meetings/end', method: 'GET', isArray: false},
            'getParticipants': {url: 'api/telehealth-meetings/participants', method: 'GET', isArray: true}
        });
    }
})();
